import { Stack, useTheme } from "@mui/material";
import { type FC, useState } from "react";
import { ExpenseCategoryHeader } from "web_myplann/Finances/Components/ExpenseCategoryHeader";
import { ExpenseRowList } from "web_myplann/Finances/Components/ExpenseRowList";
import type { ExpenseFormEntry } from "web_myplann/Finances/Forms/expenseEntrySchema";
import type { IndexedExpense } from "web_myplann/Finances/Helpers/groupExpensesByType";
import { sumMonthlyPayments } from "web_myplann/Finances/Helpers/sumMonthlyPayments";
import type { ClientFinancialPlanExpenseTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AddRowButton } from "web_myplann/Shared/Components/AddRowButton";

type Props = {
	type: ClientFinancialPlanExpenseTypeEnum;
	items: IndexedExpense<ExpenseFormEntry>[];
	onAdd: () => void;
	onEdit: (index: number) => void;
	onRemove: (index: number) => void;
};

export const ExpenseCategoryCard: FC<Props> = ({
	type,
	items,
	onAdd,
	onEdit,
	onRemove,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const [expandedOverride, setExpandedOverride] = useState<boolean | null>(
		null,
	);

	const expanded = expandedOverride ?? items.length > 0;

	return (
		<Stack bgcolor={theme.palette.background.paper}>
			<ExpenseCategoryHeader
				type={type}
				total={sumMonthlyPayments(items.map(({ expense }) => expense))}
				expanded={expanded}
				onToggle={() => setExpandedOverride(!expanded)}
			/>

			{expanded && (
				<Stack borderTop={theme.colors.border.flatRowDivider}>
					<ExpenseRowList items={items} onEdit={onEdit} onRemove={onRemove} />
					<AddRowButton
						label={t(Resources.Finances.Expenses.addExpense)}
						onClick={onAdd}
						noBorder={items.length > 0}
					/>
				</Stack>
			)}
		</Stack>
	);
};
